import Widget from 'components/LiveFeedWidget';
import useRealTimeRates from 'hooks/useRealTimeRates';

const accessKey = "BTM_ACCESS_gNO7xuPGm3Z2Ff7bQfeKkY3Mivnj1"

function App({access = accessKey}) {
  const data = useRealTimeRates(access, false)
  if(!access) return <>Access key is required</> // we can show our banner here
  return (
    <Widget data={data} />
  );
}

export default App;
